import React, { createContext, useState, type ReactNode, useEffect, useContext } from "react";
import storage from "../utils/storage";

export type AccountRole = "Admin" | "Partner";
export interface Account {
    name: string;
    emailID: string;
    userID: string;
    role: AccountRole;
    token: string | null;
    isLogin: boolean;
    profileImage?: string;
}

export interface AccountContextType {
    account: Account;
    loading: boolean;
    setAccount: (account: Account) => void;
    setLoading: (loading: boolean) => void;
    logout: (navigate?: any) => void;
}

export const AccountContext = createContext<AccountContextType | undefined>(
    undefined
);

export const AccountProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [account, setAccount] = useState<Account>({
        name: "",
        emailID: "",
        userID: "",
        role: "Admin",
        token: null,
        isLogin: false,
        profileImage: "",
    });

    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const role =
            (storage.get("role") as AccountRole) || "admin";

        const token = storage.get("token");
        const name = storage.get("name") || "";
        const emailID = storage.get("emailID") || "";
        const userID = storage.get("userID") || "";
        const profileImage = storage.get("profileImage") || "";

        setAccount({
            name,
            emailID,
            userID,
            role,
            token,
            isLogin: Boolean(token) || storage.get('isLogin') === "true",
            profileImage,
        });

        setLoading(false);
    }, []);

    const logout = (navigate?: any) => {
        setAccount({
            name: "",
            emailID: "",
            userID: "",
            role: "Admin",
            token: null,
            isLogin: false,
            profileImage: "",
        });

        [
            "name",
            "emailID",
            "role",
            "token",
            "isLogin",
            "profileImage",
            "userID"
        ].forEach((key) => storage.remove(key));
        console.log('Successfully Logged Out!')
        if (navigate) navigate("/");
    };

    return (
        <AccountContext.Provider
            value={{
                account,
                setAccount,
                loading,
                setLoading,
                logout,
            }}
        >
            {children}
        </AccountContext.Provider>
    );
};

export const useAccount = (): AccountContextType => {
    const context = useContext(AccountContext);
    if (!context) {
        throw new Error(
            "useAccount must be used within AccountProvider"
        );
    }
    return context;
};
